"use client";
import { LanguageContext } from "../contexts/language/LanguageContext.js";
import "react/jsx-runtime";
import { LANGUAGES } from "../contexts/language/language.types.js";
import { useContext } from "react";
const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  const danish = { code: LANGUAGES.DANISH, label: "Dansk" };
  const english = { code: LANGUAGES.ENGLISH, label: "English" };
  if (!ctx) {
    throw new Error(
      "useLanguage hook was called outside of context, make sure your app is wrapped with LanguageProvider component"
    );
  }
  const { language, setLanguage } = ctx;
  const languagePath = language === LANGUAGES.ENGLISH ? `/${LANGUAGES.ENGLISH}/` : "/";
  return {
    language,
    languagePath,
    isDanish: language === LANGUAGES.DANISH,
    isEnglish: language === LANGUAGES.ENGLISH,
    setLanguage,
    oppositeLang: language === LANGUAGES.DANISH ? english : danish
  };
};
export {
  useLanguage
};
